// extracted by mini-css-extract-plugin
export default {"check":"check_check__9nmZp","input":"check_input__S2NPV"};